import { useEffect, useState } from 'react'
import { Button, Form, Table, Modal } from 'react-bootstrap'
import { FaPencil, FaPlus } from 'react-icons/fa6'
import {
    addFranchise,
    deleteFranchise,
    getFranchise,
    updateFranchise,
    updateFranchiseStatus
} from '../../Services/franchiseService'
import toast from 'react-hot-toast'
import FranchiseModal from '../../Components/Modals/FranchiseModal'
import { FaCheck, FaEdit, FaTrash } from 'react-icons/fa'
import { IoCloseSharp } from 'react-icons/io5'
import DeleteFranchiseModal from '../../Components/Modals/DeleteFranchiseModal'

const AddFranchise = () => {

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedFranchise, setSelectedFranchise] = useState(null);

    const STATUS_CONFIG = {
        true: {
            color: "#10b981",
            bg: "rgba(16,185,129,0.12)",
            label: "Active",
            icon: "✓",
        },
        false: {
            color: "#ef4444",
            bg: "rgba(239,68,68,0.12)",
            label: "In Active",
            icon: "✕",
        },
    };

    const [loading, setLoading] = useState(false)
    const [franchises, setFranchises] = useState([])

    const [showModal, setShowModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)

    const [formData, setFormData] = useState({
        company_pin: "",
        firstName: "",
        lastName: "",
        companyName: "",
        companyOwner: "",
        orderPrefix: "",
        password: "",
        shippingoffice: "",
        pobox: "",
        cnic: "",
        contact: ""
    })

    const resetForm = () => {
        setFormData({
            company_pin: "",
            firstName: "",
            lastName: "",
            companyName: "",
            companyOwner: "",
            orderPrefix: "",
            password: "",
            shippingoffice: "",
            pobox: "",
            cnic: "",
            contact: ""
        })
    }

    const handleShow = () => {
        resetForm()
        setIsEdit(false)
        setShowModal(true)
    }

    const getAllFranchises = async () => {
        const response = await getFranchise()

        if (
            response.status === 200 ||
            response.status === 201 ||
            response.status === "success"
        ) {
            setFranchises(response.data || [])
        } else {
            toast.error(response.message || "Failed to fetch franchises")
        }
    }

    useEffect(() => {
        getAllFranchises()
    }, [])

    const handleEdit = (franchise) => {
        setIsEdit(true)

        setFormData({
            company_pin: franchise.company_pin || "",

            firstName: franchise.firstName || "",
            lastName: franchise.lastName || "",

            companyName: franchise.company_name || "",
            companyOwner: franchise.owner_name || "",
            orderPrefix: franchise.order_prefix || "",

            password: "",

            shippingoffice: franchise.shipping_address || "",
            pobox: franchise.po_box || "",
            cnic: franchise.cnic || "",
            contact: franchise.contact || ""
        })

        setShowModal(true)
    }


    const handleOwnerChange = (e) => {
        const value = e.target.value;

        if (value.includes(" ")) return; // ignore space input

        setFormData({
            ...formData,
            companyOwner: value
        });
    };

    const handleSubmit = async () => {
        setLoading(true)

        const body = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            company_name: formData.companyName,
            owner_name: formData.companyOwner,
            order_prefix: formData.orderPrefix,
            password: formData.password,
            shipping_address: formData.shippingoffice,
            po_box: formData.pobox,
            cnic: formData.cnic,
            contact: formData.contact
        }

        console.log("IS EDIT:", isEdit)
        console.log("COMPANY PIN:", formData.company_pin)
        console.log("PAYLOAD:", body)

        const response = isEdit
            ? await updateFranchise(formData.company_pin, body)
            : await addFranchise(body)

        if (
            response.status === 200 ||
            response.status === 201 ||
            response.status === "success"
        ) {
            setShowModal(false)
            resetForm()
            setIsEdit(false)
            getAllFranchises()

            toast.success(
                isEdit
                    ? "Franchise updated successfully"
                    : "Franchise added successfully"
            )
        } else {
            toast.error(response.message || "Failed")
        }

        setLoading(false)
    }

    const handleStatus = async (id, status) => {
        setLoading(true)

        const body = {
            is_active: !status
        }

        const response = await updateFranchiseStatus(id, body)

        if (
            response.status === 200 ||
            response.status === 201 ||
            response.status === "success"
        ) {
            getAllFranchises()
            toast.success("Status updated successfully")
        } else {
            toast.error(response.message || "Failed to update status")
        }

        setLoading(false)
    }

    const handleDeleteClick = (franchise) => {
        setSelectedFranchise(franchise);
        setShowDeleteModal(true);
    };


    const handleConfirmDelete = async () => {
        setLoading(true);

        const response = await deleteFranchise(selectedFranchise.company_pin);

        if (response.status === "success" || response.status === 200) {
            toast.success("Franchise deleted successfully");
            getAllFranchises();
            setShowDeleteModal(false);
            setSelectedFranchise(null);
        } else {
            toast.error(response.message || "Delete failed");
        }

        setLoading(false);
    };

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <h3>Franchise</h3>
                    </div>

                    <div className="col-auto">
                        <button
                            className='oms-btn oms-btn-primary'
                            size='sm'
                            onClick={handleShow}
                        >
                            <FaPlus size={14} /> Add Franchise
                        </button>
                    </div>
                </div>

                <div className="col-12 mt-3">
                    <div className="oms-table-wrap">
                        <div className="oms-table-header">
                            <div>
                                <span className="oms-table-title">
                                    Franchise Records
                                </span>

                                <span className="oms-table-count">
                                    {franchises.length} franchise
                                </span>
                            </div>
                        </div>

                        {franchises.length === 0 ? (
                            <div className="oms-empty">
                                <div className="oms-empty-icon">🔍</div>
                                <div className="oms-empty-text">
                                    No franchise found
                                </div>
                            </div>
                        ) : (
                            <div style={{ overflowX: "auto" }}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Company Name</th>
                                            <th>Admin</th>
                                            <th>Shipping Office</th>
                                            <th>Pin</th>
                                            <th>CNIC</th>
                                            <th>Contact</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {franchises.map((franchise, index) => {
                                            const st =
                                                STATUS_CONFIG[franchise.is_active]

                                            return (
                                                <tr key={franchise.id}>
                                                    <td>{index + 1}</td>

                                                    <td>
                                                        <div className="oms-track-id">
                                                            {franchise.company_name}
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div style={{
                                                            fontSize: 12,
                                                            color: "var(--text-muted)"
                                                        }}>
                                                            {franchise.owner_name}
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div
                                                            className="oms-customer"
                                                            style={{
                                                                textTransform: "capitalize"
                                                            }}
                                                        >
                                                            {franchise.shipping_address}
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div
                                                            className="oms-phone"
                                                            style={{
                                                                whiteSpace: "pre"
                                                            }}
                                                        >
                                                            {franchise.company_pin}
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className="oms-address">
                                                            {franchise.cnic}
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div style={{
                                                            fontSize: 12,
                                                            color: "white"
                                                        }}>
                                                            {franchise.contact}
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <span
                                                            className="oms-badge"
                                                            style={{
                                                                background: st?.bg,
                                                                color: st?.color
                                                            }}
                                                        >
                                                            {st?.icon} {st?.label}
                                                        </span>
                                                    </td>

                                                    <td>
                                                        <div className="oms-actions">

                                                            <div
                                                                className="oms-icon-btn print"
                                                                onClick={() => handleEdit(franchise)}
                                                            >
                                                                <FaPencil size={10} />
                                                            </div>

                                                            {!franchise?.is_active && (
                                                                <div
                                                                    className="oms-icon-btn print"
                                                                    onClick={() =>
                                                                        handleStatus(
                                                                            franchise.company_pin,
                                                                            franchise.is_active
                                                                        )
                                                                    }
                                                                >
                                                                    <FaCheck size={10} />
                                                                </div>
                                                            )}

                                                            {franchise?.is_active && (
                                                                <div
                                                                    className="oms-icon-btn cancel"
                                                                    onClick={() =>
                                                                        handleStatus(
                                                                            franchise.company_pin,
                                                                            franchise.is_active
                                                                        )
                                                                    }
                                                                >
                                                                    <IoCloseSharp size={14} />
                                                                </div>
                                                            )}

                                                            <div
                                                                className="oms-icon-btn cancel"
                                                                onClick={() => handleDeleteClick(franchise)}
                                                            >
                                                                <FaTrash size={10} />
                                                            </div>

                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <FranchiseModal
                showModal={showModal}
                setShowModal={setShowModal}
                formData={formData}
                setFormData={setFormData}
                handleSubmit={handleSubmit}
                loading={loading}
                isEdit={isEdit}
                handleOwnerChange={handleOwnerChange}
            />


            <DeleteFranchiseModal
                showDeleteModal={showDeleteModal}
                setShowDeleteModal={setShowDeleteModal}
                selectedFranchise={selectedFranchise}
                handleConfirmDelete={handleConfirmDelete}
                loading={loading}
            />
        </>
    )
}

export default AddFranchise